import React from "react";
import "./StatusCard.scss";
const StatusCard = props => {
  const {status} = props;
  const setClassName = status => {
    if (status == "CB") {
      return "normal";
    } else if (status == "DB") {
      return "almost";
    } else if (status == "HL") {
      return "expired";
    }
  };
  const setText = status => {
    if (status == "CB") {
      return "Chưa bán";
    } else if (status == "DB") {
      return "Đã bán";
    } else if (status == "HL") {
      return "Đã hoàn lại";
    }
  };
  return (
    <div className={`${setClassName(status)} status-card`}>
      {setText(status)}
    </div>
  );
};
export default StatusCard;
